import * as React from "react";
import {COLORS} from "../../utils"

function ComputerVisionIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      fill="#002E3A"
      stroke={COLORS.C1}
      strokeWidth="2.5"
      {...props}
    >
      <path
        d="M85,78c-2.97,0-5.43,2.17-5.91,5H68.1c-0.61,0-1.1-0.49-1.1-1.1V70c0-0.02-0.01-0.04-0.01-0.07
	c9.71-3.62,18.11-10.31,23.86-19.38c0.21-0.33,0.21-0.74,0-1.07C85.11,40.4,76.7,33.69,66.99,30.07c0-0.02,0.01-0.04,0.01-0.07V18.1
	c0-0.61,0.49-1.1,1.1-1.1h10.99c0.48,2.83,2.94,5,5.91,5c3.31,0,6-2.69,6-6s-2.69-6-6-6c-2.97,0-5.43,2.17-5.91,5H68.1
	c-1.71,0-3.1,1.39-3.1,3.1v11.26c-4.46-1.44-9.17-2.23-14-2.33v-6.12c2.83-0.48,5-2.94,5-5.91c0-3.31-2.69-6-6-6s-6,2.69-6,6
	c0,2.97,2.17,5.43,5,5.91v6.12c-4.83,0.1-9.54,0.88-14,2.33V18.1c0-1.71-1.39-3.1-3.1-3.1H20.91c-0.48-2.83-2.94-5-5.91-5
	c-3.31,0-6,2.69-6,6s2.69,6,6,6c2.97,0,5.43-2.17,5.91-5H31.9c0.61,0,1.1,0.49,1.1,1.1V30c0,0.02,0.01,0.04,0.01,0.07
	C23.3,33.69,14.89,40.4,9.15,49.48c-0.21,0.33-0.21,0.74,0,1.07c5.75,9.07,14.15,15.76,23.86,19.38c0,0.02-0.01,0.04-0.01,0.07v11.9
	c0,0.61-0.49,1.1-1.1,1.1H20.91c-0.48-2.83-2.94-5-5.91-5c-3.31,0-6,2.69-6,6s2.69,6,6,6c2.97,0,5.43-2.17,5.91-5H31.9
	c1.71,0,3.1-1.39,3.1-3.1V70.64c4.46,1.44,9.17,2.23,14,2.32v6.12c-2.83,0.48-5,2.94-5,5.91c0,3.31,2.69,6,6,6s6-2.69,6-6
	c0-2.97-2.17-5.43-5-5.91v-6.12c4.83-0.1,9.54-0.88,14-2.32V81.9c0,1.71,1.39,3.1,3.1,3.1h10.99c0.48,2.83,2.94,5,5.91,5
	c3.31,0,6-2.69,6-6S88.31,78,85,78z M85,12c2.21,0,4,1.79,4,4s-1.79,4-4,4s-4-1.79-4-4S82.79,12,85,12z M15,20c-2.21,0-4-1.79-4-4
	s1.79-4,4-4s4,1.79,4,4S17.21,20,15,20z M15,88c-2.21,0-4-1.79-4-4s1.79-4,4-4s4,1.79,4,4S17.21,88,15,88z M46,15c0-2.21,1.79-4,4-4
	s4,1.79,4,4s-1.79,4-4,4S46,17.21,46,15z M11.19,50.01C19.76,36.84,34.22,29,50,29s30.24,7.84,38.81,21.01
	C80.23,63.17,65.77,71,50,71S19.77,63.17,11.19,50.01z M54,85c0,2.21-1.79,4-4,4s-4-1.79-4-4s1.79-4,4-4S54,82.79,54,85z M85,88
	c-2.21,0-4-1.79-4-4s1.79-4,4-4s4,1.79,4,4S87.21,88,85,88z M67,50c0-9.37-7.63-17-17-17s-17,7.63-17,17s7.63,17,17,17
	S67,59.37,67,50z M35.05,51H38c0.55,0,1-0.45,1-1s-0.45-1-1-1h-2.95c0.5-7.47,6.48-13.45,13.95-13.95V38c0,0.55,0.45,1,1,1
	s1-0.45,1-1v-2.95c7.47,0.5,13.45,6.48,13.95,13.95H62c-0.55,0-1,0.45-1,1s0.45,1,1,1h2.95c-0.5,7.47-6.48,13.45-13.95,13.95V62
	c0-0.55-0.45-1-1-1s-1,0.45-1,1v2.95C41.53,64.45,35.55,58.47,35.05,51z M50,55c2.76,0,5-2.24,5-5s-2.24-5-5-5s-5,2.24-5,5
	S47.24,55,50,55z M50,47c1.65,0,3,1.35,3,3s-1.35,3-3,3s-3-1.35-3-3S48.35,47,50,47z"
      ></path>
    </svg>
  );
}

export default ComputerVisionIcon;
